import styled from "styled-components";

export const Container = styled.div`
	.react-pdf__Page__textContent {
		display: none;
	}

	.react-pdf__Page__annotations {
		display: none;
	}
`;
